var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nebIconButton"},[(_vm.tooltip !== '')?_c('neb-tooltip',{attrs:{"content":_vm.tooltip}},[_c('button',{staticClass:"nebIconButton-button",class:[
        _vm.size,
        { selected: _vm.selected, disabled: _vm.disabled }
      ],on:{"click":_vm.onClick}},[_c('neb-icon',{attrs:{"name":_vm.icon,"height":_vm.iconSize,"width":_vm.iconSize}})],1)]):_vm._e(),(_vm.tooltip === '')?_c('button',{staticClass:"nebIconButton-button",class:[
      _vm.size,
      { selected: _vm.selected, disabled: _vm.disabled }
    ],on:{"click":_vm.onClick}},[_c('neb-icon',{attrs:{"name":_vm.icon,"height":_vm.iconSize,"width":_vm.iconSize}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }